import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function obtenerIncidencias(payload) {
  return { type: types.FETCH, payload };
}

function incidenciaModificada(payload) {
  return { type: types.CHANGED, payload };
}

function incidenciaEliminada(payload) {
  return { type: types.REMOVED, payload };
}

function resetIncidencias() {
  return { type: types.RESET };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  obtenerIncidencias,
  incidenciaModificada,
  incidenciaEliminada,
  resetIncidencias
};



// WEBPACK FOOTER //
// ./src/ducks/incidencias/actions.js